import { Greeter } from './Components/Greeter';
import { LinkConditioner, TestimonialShortener, ListenEvent } from './Globals/index';

export class PageLoadEvents {
    static Greeter = Greeter;
    static LinkConditioner = LinkConditioner;
    static TestimonialShortener = TestimonialShortener;
}

export class ClickEvents {
    static DropdownSubmenu = ListenEvent.clickDropdownSubmenu;
    static RevertImpersonation = ListenEvent.clickRevertImpersonation
}